import VisibilityOffTwoToneIcon from '@mui/icons-material/VisibilityOffTwoTone';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import { Alert, Box, CircularProgress, Link, Stack, IconButton, InputAdornment, TextField } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import axiosInstance from '../../../api';
import SERVER_API_URL from '../../../config';
import CustomButton from '../../../components/custom-button/CustomButton';

export default function SetNewPassword() {
  const [error, setError] = useState();
  const [disabled, setDisabled] = useState(false);
  const [visiblePassword, setVisiblePassword] = useState(false);
  const [visibleRepeat, setVisibleRepeat] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    const data = new FormData(e.currentTarget);
    if (data.get('password').length < 8) {
      setError('የይለፍ ቃል ቢያንስ 8 ቁምፊዎች መሆን አለበት።');
      setDisabled(false);
      return;
    }

    if (data.get('repeat_passwd') !== data.get('password')) {
      setError('የይለፍ ቃሎች ተመሳሳይ አይደሉም');
      setDisabled(false);
      return;
    }

    try {
      const response = await axiosInstance.patch(`${SERVER_API_URL}/auth/resetPassword`, {
        email,
        newPassword: data.get('password'),
      });
      if (response.status === 200) {
        setError(null);
        localStorage.clear();
        navigate('/login');
      }
    } catch (e) {
      if (e.response.status === 404) {
        setError('ከዚህ ኢሜይል አድራሻ ጋር የተገናኘ ተጠቃሚ የለም።');
        return;
      }
      setDisabled(false);
    }
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          mx: 'auto',
        }}
      >
        <Stack spacing={2} sx={{ my: 2 }}>
          {error && (
            <Alert sx={{ width: '100%' }} severity="error">
              {error}
            </Alert>
          )}
          <TextField
            id="password"
            name="password"
            type={visiblePassword ? 'text' : 'password'}
            label="የይለፍ ቃል"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setVisiblePassword(!visiblePassword)}>
                    {visiblePassword ? <VisibilityTwoToneIcon /> : <VisibilityOffTwoToneIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            id="repeat_passwd"
            name="repeat_passwd"
            type={visibleRepeat ? 'text' : 'password'}
            label="የማለፊያ ቃልዎን ይድገሙ"
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setVisibleRepeat(!visibleRepeat)}>
                    {visibleRepeat ? <VisibilityTwoToneIcon /> : <VisibilityOffTwoToneIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <CustomButton fullWidth size="large" type="submit" variant="contained" disabled={disabled}>
          {!disabled && <>አስገባ</>}
          {disabled && (
            <>
              <CircularProgress style={{ width: '20px', height: '20px' }} />  አስገባ...
            </>
          )}
        </CustomButton>

        <Stack direction="row" justifyContent="right" sx={{ mt: 2 }}>
          <Link onClick={() => navigate('/login')} sx={{ cursor: 'pointer' }} variant="subtitle2" underline="hover">
            ተመለስ
          </Link>
        </Stack>
      </Box>
    </>
  );
}
